import {ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef} from '@angular/core';
import {Mosaic} from './mosaic.type';

@Component({
    selector: 'amg-mosaic',
    templateUrl: './mosaic.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MosaicComponent<MosaicItem> implements OnInit {
    @Input() itemTemplate: TemplateRef<HTMLElement>;
    @Input() mosaic: Mosaic<MosaicItem>;


    constructor() {
    }

    ngOnInit(): void {


        console.log(this.mosaic);
    }

}
